var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScribe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2458_7373)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8795 9.388C10.699 9.5692 10.4673 9.69067 10.2155 9.736L7.21554 10.276C7.01852 10.3117 6.81582 10.2995 6.6245 10.2404C6.43317 10.1814 6.25883 10.0773 6.11613 9.93687C5.97343 9.79643 5.86655 9.62376 5.8045 9.4334C5.74244 9.24304 5.72702 9.04056 5.75954 8.843L6.25954 5.803C6.30197 5.54414 6.42477 5.3052 6.61054 5.12L10.7495 1H3.49954C3.10171 1 2.72018 1.15804 2.43888 1.43934C2.15757 1.72064 1.99954 2.10218 1.99954 2.5V11.419L1.02554 14.342C0.997299 14.4269 0.992377 14.5179 1.01128 14.6054C1.03019 14.6928 1.07223 14.7736 1.13301 14.8393C1.1938 14.905 1.27111 14.9532 1.35686 14.9788C1.44262 15.0044 1.53368 15.0066 1.62054 14.985L5.56054 14H13.4995C13.8974 14 14.2789 13.842 14.5602 13.5607C14.8415 13.2794 14.9995 12.8978 14.9995 12.5V5.25L10.8795 9.388ZM13.3185 1.077C13.1349 1.00046 12.9327 0.980409 12.7376 1.01942C12.5426 1.05843 12.3636 1.15473 12.2235 1.296L7.49354 6.006L6.99354 9.046L9.99354 8.506L14.7035 3.776C14.7973 3.68304 14.8717 3.57244 14.9224 3.45058C14.9732 3.32872 14.9993 3.19801 14.9993 3.066C14.9993 2.93399 14.9732 2.80328 14.9224 2.68142C14.8717 2.55956 14.7973 2.44896 14.7035 2.356L13.6435 1.296C13.5508 1.20192 13.4403 1.12715 13.3185 1.076V1.077Z",
    fill: "#29C0BB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2458_7373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScribe);
export default __webpack_public_path__ + "static/media/scribe.871cf51380ee30bbe4c8fd9eefb1307d.svg";
export { ForwardRef as ReactComponent };